// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__2QOHS","tab":"styles_tab__3EOxa","icon":"styles_icon__2Ss-x","text":"styles_text__Inz4M","active":"styles_active__3UUpl"};